import React, { useEffect, useState} from "react";
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import BigNumber from "bignumber.js";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
import { useSnackbar } from 'notistack';
import Countdown from 'react-countdown';

const BalanceTokens = ({ accounts, readSales , onConnect }) => {
  const [balance, setBalance] = useState("")
  const [address, setAddress] = useState("")
  const [processing, setProcessing] = useState(false)

  const setState = async () => {
    if (accounts && address == "") {
      setAddress(accounts[0])
    }
  }

  const onCheck = async () => {
    setProcessing(true)
    try {
      const decimals = new BigNumber(18)
      const balance = await readSales.methods.balanceOf(
        address
      ).call()
      setBalance(new BigNumber(balance).div(new BigNumber(10).pow(decimals)).toString(10))
      setProcessing(false)
    } catch (e) {
      setProcessing(false)
    }
  }
  useEffect(() => {
    setState()
  })

  return (
    <Container>
      <Typography component="h1" variant="h5">
        Your Balance
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Container className="MuiOutlinedInput-input">
            <Typography variant="h6">
              Your wallet address
            </Typography>
          </Container>
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField variant="outlined" onChange={(e) => setAddress(e.target.value)} value={address} fullWidth={true} />
        </Grid>
        <Grid container justify={'flex-end'}>
          <Button variant="contained" color="primary" onClick={onCheck} disabled={processing}>
              <FormattedMessage id="App.BalanceTokens.Check" />
            </Button>
        </Grid>
        <Grid item xs={12} sm={3}></Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6" align="center">
            {processing ?
              (<LinearProgress />) :
              (balance && balance + "EAR")
            }
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}></Grid>
      </Grid>
    </Container>
  );
}
export default BalanceTokens;
